export default __webpack_public_path__ + "static/media/close-circle-filled.2b9a0857.svg";